import Button from "@hudson/ui/components/FormFields/Button";

export interface Action {
  disabled?: boolean;
  label: string;
  loading?: boolean;
  onClick: () => any;
}

function Actions({ actions }: { actions: Action[] }): JSX.Element {
  return (
    <div className="flex flex-row xs:flex-row-reverse space-x-4 self-end ">
      <Button
        className="text-lg"
        disabled={actions[0].disabled}
        loading={actions[0].loading}
        onClick={() => actions[0].onClick()}
        small
      >
        {actions[0].label}
      </Button>

      {actions.slice(1).map((action) => (
        <div key={action.label} className="flex border-l border-[--primary-color] pl-4">
          <Button
            className="text-lg"
            disabled={action.disabled}
            loading={action.loading}
            onClick={() => action.onClick()}
            small
          >
            {action.label}
          </Button>
        </div>
      ))}
    </div>
  );
}

export default Actions;
